import type * as Api from 'Api'

export const geoLocationErrorHandbook: Api.ErrorsHandbook<'default'> = {
  default: [],
}
